import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

const Logo = () => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: '8px 16px'
    }} onClick={() => window.location.href = '/'}>
        <Text strong style={{ fontSize: 24, letterSpacing: -0.5 }}>
            OpenEP
        </Text>
    </div>
);

export default Logo;
